import React from 'react';

// @ts-ignore
export const FirstPlateSeparatorIcon = () => (
  <svg
    data-name="Group 407"
    height="3.19"
    id="Group_407"
    viewBox="0 0 3.19 3.19"
    width="3.19"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.595" cy="1.595" data-name="Ellipse 1" id="Ellipse_1" r="1.595" />
    <g id="insignia-escudo-con-contorno" transform="translate(0.54 0.437)">
      <g data-name="Group 400" id="Group_400" transform="translate(0 0)">
        <path
          d="M42.211,27.614c-.29.648.813.659.97,1.068.02.053.017.053.037,0,.157-.409,1.26-.42.97-1.068a.894.894,0,0,1,.055-1.008.045.045,0,0,0,0-.059l-.261-.3a.052.052,0,0,0-.061-.011.85.85,0,0,1-.686-.021.1.1,0,0,0-.072,0,.85.85,0,0,1-.686.021.052.052,0,0,0-.061.011l-.261.3a.045.045,0,0,0,0,.059A.893.893,0,0,1,42.211,27.614Z"
          data-name="Path 187"
          id="Path_187"
          transform="translate(-42.145 -26.207)"
        />
      </g>
    </g>
    <path
      d="M135.273,140.866l-.188.355-.4.069.28.289-.057.4.361-.177.361.177-.057-.4.28-.289-.4-.069Z"
      data-name="Path 189"
      id="Path_189"
      transform="translate(-133.686 -139.863)"
    />
  </svg>
);
